import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed';
export default {
  props: {
    visible: Boolean,
    clauseItem: Object
  },
  components: {
    VuePdfEmbed
  },
  data() {
    return {
      waitTime: 10,
      timer: null
    };
  },
  watch: {
    visible(newV) {
      if (newV) {
        this.waitTime = 10;
        if (this.timer) {
          clearInterval(this.timer);
        }
        console.log(this.clauseItem, 'this.clauseItem');
        this.$nextTick(() => {
          // let iframeWin = this.$refs.clause.contentDocument.body || this.$refs.clause.document.body;
          // console.log(this.$refs.clause, iframeWin, iframeWin.scrollHeight, 'this.$refs.clause');
          // if (iframeWin) {
          //   this.$refs.iframeBox.height = iframeWin.scrollHeight + 'px';
          // }
          this.timer = setInterval(() => {
            this.waitTime--;
            if (this.waitTime === 0) {
              clearInterval(this.timer);
            }
          }, 1000);
        });
      }
    }
  },
  //   created() {
  //     console.log(this.clauseItem, 'this.clauseItem');
  //   },
  methods: {},
  beforeDestroy() {
    clearInterval(this.timer);
  }
};